import sharesproApi from 'rtkQuery/sharespro/sharesproApiService';
import { SharesproApiResponse } from 'rtkQuery/sharespro/types/sharesproApiResponse';
import getFormDataFromObject from 'utils/getFormDataFromObject';

export const commonApi = sharesproApi.injectEndpoints({
  endpoints: (builder) => ({
    sendAppActivity: builder.mutation<
      SharesproApiResponse<boolean>,
      ApiAppActivityRequestData | void
    >({
      query: (body) => ({
        url: '/v3/common/app-activity',
        method: 'POST',
        body,
      }),
    }),
    uploadFile: builder.mutation<
      SharesproApiResponse<ApiUploadChatFileResponse>,
      File
    >({
      query: (file) => ({
        url: '/v3/common/upload',
        method: 'POST',
        sendToken: true,
        body: getFormDataFromObject({
          file,
        }),
      }),
    }),
  }),
});

export const { useSendAppActivityMutation, useUploadFileMutation } = commonApi;
